import React, { FC } from 'react';

import ShareIcon, { ShareIconProps } from '..';
import './styles.scss';

interface GroupProps {
  socialLinks: ShareIconProps[];
}

const Group: FC<GroupProps> = ({ socialLinks }) => {
  return (
    <div className="ourAddressWebGroup">
      {socialLinks.map((item) => (
        <ShareIcon name={item.name} link={item.link} key={`${item.name}-${item.link}`} />
      ))}
    </div>
  );
};

export default Group;
